export default __webpack_public_path__ + "static/universal-dashboard-397b7f4fabb158ff40193529e4f50910.png";